/**
 * dir-w | backOffice
 * Shared component for view field
 *
 * Last update : August 14, 2024 | @rizkiprasetya
 */

import { Component, input, Input } from '@angular/core';
import { Configuration } from '../../../config/configuration';

@Component({
    selector: 'app-view-field',
    templateUrl: './view-field.component.html',
    styleUrl: './view-field.component.css',
    standalone: false
})
export class ViewFieldComponent {

  protected baseURL: string = Configuration.baseURL;

  @Input() singleColumn: boolean = true;
  @Input() nextColumn: boolean = false;
  @Input() firstRow: boolean = false;
  @Input() caption: string = '';
  @Input() value: string = '';
  @Input() type: string = 'TEXT';
  @Input() textAlign: string = 'LEFT';
  @Input() textColor: string = '';
  @Input() toolTipText: string = '';
  @Input() toolTipCaption: string = '';
}
